import React, { ComponentProps } from 'react'
import { useHistory } from 'react-router'
import { match, useRouteMatch } from 'react-router-dom'

import { ReactComponent as ChatIcon } from '@app/assets/Small/Outline/Chat.svg'
import { ReactComponent as GavelIcon } from '@app/assets/Small/Outline/Gavel.svg'
import { useIntl } from '@app/intl/Intl'
import { bemJoin, classNames } from '@app/lib/bem'
import {
  TileButton,
  TileButtonIconSize,
  TileButtonPaddingVariant,
  TileButtonTextSize,
  TileButtonVariant
} from '@app/lib/inputs/TileButton/TileButton'
import { MergeProps } from '@app/lib/types'
import { getCourtCasesBasePath } from '@app/modules/CourtCases'
import { getMessagesPath } from '@app/modules/Messages'
import { useMobile } from '@app/services/useMobile'

import './ConsultationTypeTabs.scss'

export type ConsultationTypeTabsProps = MergeProps<
  ComponentProps<'div'>,
  {
    selected: 'AskLawyerChat' | 'CourtCase'
  }
>

export const ConsultationTypeTabs = ({
  selected,
  className,
  ...rest
}: ConsultationTypeTabsProps) => {
  const b = bemJoin('consultation-type-tabs')
  const { formatMessage } = useIntl()
  const history = useHistory()
  const { isMobile } = useMobile()
  const match: match<{ id: string }> = useRouteMatch()
  const customerId = Number(match.params.id)

  return (
    <div {...rest} className={classNames(b(), className)}>
      <TileButton
        text={formatMessage({ id: 'ConsultationTypeTabs.AskLawyerChat' })}
        variant={TileButtonVariant.Horizontal}
        paddingVariant={
          isMobile ? TileButtonPaddingVariant.Compact : TileButtonPaddingVariant.Normal
        }
        textSize={isMobile ? TileButtonTextSize.Normal : TileButtonTextSize.Big}
        iconSize={isMobile ? TileButtonIconSize.Small : TileButtonIconSize.Normal}
        icon={<ChatIcon />}
        selected={selected === 'AskLawyerChat'}
        onClick={() => history.push(getMessagesPath(customerId))}
      />
      <TileButton
        text={formatMessage({ id: 'ConsultationTypeTabs.CourtCases' })}
        variant={TileButtonVariant.Horizontal}
        paddingVariant={
          isMobile ? TileButtonPaddingVariant.Compact : TileButtonPaddingVariant.Normal
        }
        textSize={isMobile ? TileButtonTextSize.Normal : TileButtonTextSize.Big}
        iconSize={isMobile ? TileButtonIconSize.Small : TileButtonIconSize.Normal}
        icon={<GavelIcon />}
        selected={selected === 'CourtCase'}
        onClick={() => history.push(getCourtCasesBasePath(customerId))}
      />
    </div>
  )
}
